exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".content[data-v-3f31682b]{font-family:华文楷体;font-size:10.5pt;display:-moz-inline-box;display:inline-block;min-width:15px;border-bottom:1px solid #ff4a7d;min-height:17px}.content[data-v-3f31682b]:focus{outline:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-3f31682b","scoped":true,"hasInlineConfig":false}!./~/less-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/modules/supplier/contract/edit/contract_7_1.vue
// module id = 368
// module chunks = 0